import { css, useTheme } from "@emotion/react";
import { mix, rem, transparentize } from "polished";
import React from "react";
import { Link } from "react-router-dom";
import { useSetRecoilState } from "recoil";

import { Flex, Label, Text } from "../../base";
import { formatTokens } from "../../lib/format";
import { explorerOpenAtom } from "./atoms";

const SearchLink = Flex.withComponent(Link);

const renderIconComponent = (icon: any, props = {}) => {
  let iconComponent;
  if (typeof icon === "string") {
    iconComponent = <img alt="" src={icon} {...props} />;
  } else if (typeof icon === "function") {
    iconComponent = icon(props);
  } else if (typeof icon === "object") {
    iconComponent = icon;
  }

  return iconComponent;
};

const SearchItem = ({ text, slug, itemType, icon, right = null }) => {
  const { color: colors } = useTheme();
  const setExplorerOpen = useSetRecoilState(explorerOpenAtom);

  const color = mix(0.5, colors?.start, colors?.end);

  return (
    <SearchLink
      between
      css={css`
        margin-left: -${rem(10)};
        margin-right: -${rem(10)};
        padding: ${rem(10)};
        border-radius: ${rem(8)};

        cursor: pointer;

        &:hover {
          background: ${transparentize(0.85, color)};
        }
      `}
      to={`/explore/${itemType}/${slug}`}
      onClick={() => setExplorerOpen(false)}
    >
      <Flex start>
        {renderIconComponent(icon, {
          stroke: color,
          css: css`
            width: ${rem(21)};
            height: ${rem(21)};

            margin-right: ${rem(12)};
            /* border: 0.5px solid rgba(0, 0, 0, 0.15); */
          `,
        })}
        <Text color={color}>{text}</Text>
      </Flex>
      {right ? (
        <Flex end>
          <Label
            light
            small
            css={css`
              font-size: ${rem(16)};
              justify-self: flex-end;
              color: #aaa;
            `}
          >
            {formatTokens(right)}
          </Label>
        </Flex>
      ) : null}
    </SearchLink>
  );
};

export default SearchItem;
